var _desc, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 18L3 13M3 2L3 0M13 5L13 0M13 18L13 16M0 5C0 3.34 1.34 2 3 2C4.65 2 6 3.34 6 5L6 7C6 8.65 4.65 10 3 10C1.34 10 0 8.65 0 7L0 5ZM10 11C10 9.34 11.34 8 13 8C14.65 8 16 9.34 16 11L16 13C16 14.65 14.65 16 13 16C11.34 16 10 14.65 10 13L10 11Z",
    stroke: "#0478FE",
    strokeOpacity: 1,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.07e4701829fa4dddf34b81293bc38b05.svg";
export { ForwardRef as ReactComponent };